import { Skeleton } from '@/components/ui/skeleton';

function CommentSkeletonItem() {
  return (
    <div className="flex gap-4">
      <Skeleton className="h-9 w-9 rounded-full flex-shrink-0 mt-0.5" />
      <div className="flex-1 bg-muted/30 rounded-2xl p-4 space-y-2">
        <div className="flex justify-between items-center">
          <Skeleton className="h-4 w-24" />
          <Skeleton className="h-3 w-16" />
        </div>
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-3/4" />
      </div>
    </div>
  );
}

export function CommentSkeleton() {
  return (
    <div className="space-y-8">
      <Skeleton className="h-4 w-24" />
      <div className="space-y-8">
        <CommentSkeletonItem />
        <CommentSkeletonItem />
        <CommentSkeletonItem />
      </div>
    </div>
  );
}
